import { axiosInstance } from "../apiInstance";

export async function init() {
    try {
        const response = await axiosInstance.get(`?action=init&format=new`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

 

export async function sendOTP(mobile) {
    try {
        const response = await axiosInstance.get(`?action=otp&mobile=${mobile}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function pinCode(memberId) {
    return axiosInstance.post(`?pincode=${memberId}`)
        .then((response) => {
            return response.data;
        }).catch((error) => {
            throw error;
        })
}

export async function getMember(memberId) {
    return axiosInstance.post(`?action=getmember&memberid=${memberId}`)
        .then((response) => {
            return response.data;
        }).catch((error) => {
            throw error;
        })
}

export async function newMember(payloadData) {
    return axiosInstance.post(`?action=member`, payloadData)
        .then((response) => {
            return response.data;
        }).catch((error) => {
            throw error;
        })
}